import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorTriggerProps } from "@/v2-backoffice-client/components/selector"
import { useLayerCategoryQuery } from "@/v2-backoffice-client/layer/category/layer.category.query"
import LayerCategoryLayerAddSelectorItem from "@/v2-backoffice-client/layer/category/layer/add/LayerCategoryLayerAddSelectorItem"

export type LayerCategoryLayerAddSelectorProps = SelectorTriggerProps & {
  layerFeatureCode: string
  existingCategoryCodes?: string[]
}

function LayerCategoryLayerAddSelector(
  props: LayerCategoryLayerAddSelectorProps,
) {
  const {
    layerFeatureCode,
    existingCategoryCodes = [],
    ...triggerProps
  } = props

  const { data, loading, error } = useLayerCategoryQuery()
  errorToast(error, {
    title: "Failed to query for categories",
  })

  const allCategories = data?.getLayerCategories ?? []
  const availableCategories = allCategories.filter(
    (c) => !existingCategoryCodes.includes(c.FeatureCode),
  )

  return (
    <Selector shouldFilter>
      <Selector.Trigger
        iconSrc="plus"
        disabled={triggerProps.disabled ?? availableCategories.length === 0}
        {...triggerProps}
      >
        {triggerProps.children ?? "Add Category"}
      </Selector.Trigger>

      <Selector.Content>
        <Selector.Search placeholder="Search categories..." debounce={0} />
        <Selector.List
          emptyLabel="No categories found"
          isLoading={loading}
          error={error}
        >
          {availableCategories.map((cat) => (
            <LayerCategoryLayerAddSelectorItem
              key={cat.FeatureCode}
              category={cat}
              layerFeatureCode={layerFeatureCode}
            />
          ))}
        </Selector.List>
      </Selector.Content>
    </Selector>
  )
}

export default LayerCategoryLayerAddSelector
